import { Stack } from "@octopus-energy/coral/atoms"
import { StoryblokMissingField } from "@octopus-energy/coral/storyblok"
import { StoryblokComponent, storyblokEditable } from "@storyblok/react"
import { type SbBlokCollapsingStack } from "../types"

interface DynamicCollapsingStackProps {
    blok: SbBlokCollapsingStack
}

export default function DynamicCollapsingStack({ blok }: DynamicCollapsingStackProps) {
    if (!blok?.blocks?.length) {
        return (
            <StoryblokMissingField
                blok="CollapsingStack"
                field="Blocks"
            />
        )
    }

    return (
        <Stack
            gap={blok.gap === "0" ? "none" : blok.gap}
            justifyContent={blok.justifyContent}
            alignItems={blok.alignItems}
            flexDirection={{ base: "column", md: "row" }}
            flexWrap="nowrap"
            {...storyblokEditable(blok)}
        >
            {blok.blocks.map((nestedBlok) => (
                <StoryblokComponent
                    blok={nestedBlok}
                    key={nestedBlok._uid}
                />
            ))}
        </Stack>
    )
}
